































import { Component, Vue } from 'vue-property-decorator';
import { $config } from '../services';


@Component({
  components: { },
})
export default class Landing extends Vue {
  constructor(){
    super();
  }

  async mounted(){
    console.log('--- mounted',$config.store.config)
  }

  get config(){
    return $config.store.config;
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    $config.get().then(next)
  }

}
